<template>
  <div>
    <Breadcrumbs :items="items" />
    <PageAllow controller="Quotations" action="index" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="datetimeRage"
                type="datetime"
                :label="$t('StockPosition.Fields.create')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 报价单号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="quotation_code"
                    v-model="options.quotation_code"
                    @text="quotationsKeyword = $event"
                    :label="$t('Quotations.quotationsKeyword')"
                  />
                </v-col>
                <!-- 商品名称 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="material_name"
                    v-model="options.keyword"
                    @text="materialKeyword = $event"
                    :label="$t('Quotations.mateiralKeyword')"
                  />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategory v-model="categorySelected" />
                </v-col>
                <!-- 供应商 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSuppliers v-model="supplierSelected" />
                </v-col>
                <!-- 报价单状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Quotations.status.title')"
                    :items="$consts.quotation.status"
                  />
                </v-col>
                <!-- 报价单作废状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherCancelFlgs v-model="options.cancel_flgs" />
                </v-col>
                <!-- 是否有疑义 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.question_flg"
                    :label="$t('Quotations.questionFlgs.title')"
                    :items="$consts.quotation.question_flgs"
                    :disable="
                      !(
                        options.status.indexOf(1) > -1 &&
                        options.status.length == 1
                      )
                    "
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="quotations"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              <span class="ml-3">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </span>
            </template>
            <template v-slot:item.quotation_code="{ item, index }">
              <span
                class="text-no-wrap caption font-weight-bold"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                :v-resize="!index ? $stickTableResizer() : null"
              >
                {{ item.quotation_code }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <template v-slot:item.finish_time="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.finish_time | formatTime }}
              </span>
            </template>
            <!-- 状态文字 -->
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.status | quotationStatusColor"
                :text-color="item.status | quotationStatusTextColor"
              >
                {{ item.status | quotationStatusText }}
              </v-chip>
              <v-chip
                v-if="item.status == 1"
                small
                label
                outlined
                :color="item.question_flg | quotationQuestionFlgsColor"
                class="ml-1"
              >
                {{ item.question_flg | quotationQuestionFlgsText }}
              </v-chip>
              <br />
              <v-chip
                v-if="item.cancel_flg"
                x-small
                label
                outlined
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <QuotationsActions
                :quotation="item"
                showView
                :showConfirm="item.actions.confirm"
                :showApprove="item.actions.approve"
                :showCancel="item.actions.cancel"
                @done="getQuotationsFromAPI()"
                class="ml-3"
              />
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import QuotationsActions from "./plugins/Actions";
import Quotations from "@/api/quotations";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  quotation_code: "",
  keyword: "",
  category_ids: [],
  supplier_ids: [],
  status: [1, 2],
  question_flg: [],
  cancel_flgs: [0],
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherMaterialCategory,
    SearcherSuppliers,
    SearcherStatus,
    SearcherCancelFlgs,
    QuotationsActions,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/purchases",
      },
      {
        text: i18n.t("Nav.quotation"),
        disabled: true,
      },
    ],

    headers: () => [
      {
        text: i18n.t("Quotations.Fields.quotation_code"),
        align: "start",
        class: "text-no-wrap",
        sortable: false,
        value: "quotation_code",
      },
      {
        text: i18n.t("Quotations.Fields.supplier_name"),
        align: "center",
        class: "text-no-wrap",
        sortable: false,
        value: "supplier.supplier_name",
      },
      {
        text: i18n.t("Quotations.Fields.finish_time"),
        align: "center",
        sortable: false,
        class: "text-no-wrap",
        value: "finish_time",
      },
      {
        text: i18n.t("Quotations.Fields.status"),
        align: "start",
        sortable: false,
        class: "text-no-wrap",
        value: "status",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        class: "text-no-wrap",
        value: "actions",
      },
    ],

    ...mapState(["loading", "stickTableCols"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    options: JSON.parse(
      sessionStorage.getItem("quotations-options")
        ? sessionStorage.getItem("quotations-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    quotationsKeyword: "",
    materialKeyword: "",
    categorySelected: null,
    supplierSelected: null,
    quotations: [],
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("quotations", ["categorySelected", "supplierSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "categorySelected":
                this.categorySelected = selected.value;
                break;
              case "supplierSelected":
                this.supplierSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.categorySelected = null;
      this.supplierSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.quotation_code, this.$refs.material_name].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        quotation_code: this.quotationsKeyword,
        material_name: this.materialKeyword,
      });
    },
    getQuotationsFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      Quotations.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.quotations = response.data.quotations;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        if (
          this.options.status.indexOf(1) > -1 &&
          this.options.status.length > 1 &&
          this.options.question_flg.length
        ) {
          this.options.question_flg = [];
        }
        this.getQuotationsFromAPI();
        sessionStorage.setItem(
          "quotations-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() -7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    categorySelected: {
      handler() {
        this.options.category_ids = this.categorySelected
          ? this.categorySelected.id
          : "";
        sessionStorage.setItem(
          "quotations-categorySelected",
          JSON.stringify(this.categorySelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.supplier_ids = this.supplierSelected
          ? this.supplierSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "quotations-supplierSelected",
          JSON.stringify(this.supplierSelected)
        );
      },
    },
  },
};
</script>